/*eslint-disable*/ import type { Messages } from '@lingui/core';
export const messages: Messages = JSON.parse(
  '{"native.advertisement":"Advertisement"}'
);
